import React, { useContext, useEffect, useState } from "react";
import {
  Badge,
  Container,
  FormControl,
  Grid,
  Paper,
  Typography,
  Avatar,
  IconButton,
  Box,
  Skeleton,
  Button,
  Card,
  CardContent,
  Chip,
  Tooltip,
} from "@mui/material";
import Alert from "@mui/material/Alert";
import LinearProgress from "@mui/material/LinearProgress";
import Divider from "@mui/material/Divider";
import { useTheme } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TablePagination from "@mui/material/TablePagination";
import ColumnChart from "../../components/charts/ColumnChart";
import AreaChart from "../../components/charts/AreaChart";
import MenuIcon from "../../components/icons/MenuIcon";
import VerifyIcon from "../../components/icons/VerifyIcon";
import SecurityIcon from "../../components/icons/SecurityIcon";
import ListIcon2 from "../../components/icons/ListIcon2";
import MoneyIcon from "../../components/icons/MoneyIcon";
import UncompletedIcon from "../../components/icons/UncompletedIcon";
import FailedIcon from "../../components/icons/FailedIcon";
import FolderIcon from "../../components/icons/FolderIcon";
import DownloadIcon from "../../components/icons/DownloadIcon";
import MessageIcon from "../../components/icons/MessageIcon";
import MoonIcon from "../../components/icons/MoonIcon";
import { AuthContext } from "../../context/AuthContext";
import { getDataWithToken } from "../../services/GetDataService";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import jwt_decode from "jwt-decode";
import Chart from "react-apexcharts";
import moment from "moment";
import CountUp from "react-countup";
import makeStyles from "@mui/styles/makeStyles";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import { 
  Business as BusinessIcon,
  SwapHoriz as SwapIcon,
  Check as CheckIcon
} from "@mui/icons-material";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { PulseLoader, SyncLoader } from "react-spinners";
// import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
const useStyles = makeStyles((theme) => ({
  chartContainer: {
    "& text": {
      fill: theme.palette.text.light,
    },
    "& .apexcharts-title": {
      fill: theme.palette.text.light,
    },
  },
}));
const Dashboard = ({ toggleTheme }) => {
  const theme = useTheme();
  const classes = useStyles();
  const [storeListMessage, setStoreListMessage] = useState("");
  const [storeListLoading, setStoreListLoading] = useState(false);
  const [storeList, setStoreList] = useState([]);
  const { login, admin_panel_user, logout } = useContext(AuthContext);
  const [progress, setProgress] = useState(50);
  const [page, setPage] = useState(2);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [summaryLoading, setSummaryLoading] = useState(false);
  const [summaryList, setSummaryList] = useState([]);
  const [summaryMessage, setSummaryMessage] = useState("");
  const [storeDetailLoading, setStoreDetailLoading] = useState(false);
  const [storeDetails, setStoreDetails] = useState({});
  const [storeDetailMessage, setStoreDetailMessage] = useState("");
  const [totalSummary, setTotalSummary] = useState(0);
  const [totalVerified, setTotalVerified] = useState(0);
  const [showPassword, setShowPassword] = useState(false);
  const [display, setDisplay] = useState(false);
  const [months, setMonths] = React.useState(12);
  const [selectedStoreId, setSelectedStoreId] = useState(null);
  const [hasStores, setHasStores] = useState(true);
  const [selectedProject, setSelectedProject] = useState(null);

  const handleChange = (event) => {
    setMonths(event.target.value);
    getSummaryOfaStore(event.target.value);
  };

  const handleProjectChange = (event) => {
    const projectId = event.target.value;
    const project = storeList.find(store => store.id === projectId);
    if (project) {
      setSelectedProject(project);
      setSelectedStoreId(projectId);
    }
  };
  const [chartData, setChartData] = useState({
    series: [
      {
        name: "",
        data: [],
      },
      // {
      //   name: "Revenue",
      //   data: [76, 85, 101, 98, 87, 105, 91],
      // },
      //   {
      //     name: "Free Cash Flow",
      //     data: [35, 41, 36, 26, 45, 48, 52, 53, 41],
      //   },
    ],
    options: {
      chart: {
        fontFamily: '"Roboto",sans-serif',

        toolbar: {
          show: false, //download button hide
        },
        type: "bar",
        // height: 350,
      },
      legend: {
        show: false,
        // labels: {
        //   colors: ['red', 'blue', 'green', 'purple'], // Change the legend text colors here
        // },
        // container: {
        //   background: ['blue','blue'], // Change the legend box background color here
        // },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "35%",
          endingShape: "rounded",
        },
      },
      dataLabels: {
        enabled: false,
      },
      //   stroke: {
      //     show: true,
      //     width: 2,
      //     colors: ["transparent"],
      //   },
      // xaxis: {
      //   labels: {
      //     style: {
      //       colors: "red", // Change the x-axis label color here
      //     },
      //   },
      //   categories: [],
      // },
      yaxis: {
        labels: {
          style: {
            colors: theme.palette.text.light, // Change the x-axis label color here
          },
        },
        title: {
          // text: "   ",
          text: "Attempted vs Verified",
          style: {
            colors: theme.palette.text.light, // Change the x-axis label color here
          },
        },
      },
      fill: {
        opacity: 1,
        colors: [theme.palette.primary.main, theme.palette.success.main],
      },
      tooltip: {
        theme: "dark",
        // theme: theme.palette.mode === "dark" ? "dark" : "light",
        // fillSeriesColor: true,

        y: {
          formatter: function (val) {
            return val;
          },
        },
      },
    },
    minHeight: 250,
  });

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  // React.useEffect(() => {
  //   const timer = setInterval(() => {
  //     setProgress((prevProgress) => (prevProgress >= 50 ? 10 : prevProgress + 10));
  //   }, 800);
  //   return () => {
  //     clearInterval(timer);
  //   };
  // }, []);
  const pageLoading = () => {
    let content = [];

    for (let i = 0; i < 6; i++) {
      content.push(
        <TableRow key={i}>
          <TableCell>
            <Skeleton></Skeleton>
          </TableCell>
          <TableCell>
            <Skeleton></Skeleton>
          </TableCell>
          <TableCell>
            <Skeleton></Skeleton>
          </TableCell>
          <TableCell>
            <Skeleton></Skeleton>
          </TableCell>
          <TableCell>
            <Skeleton></Skeleton>
          </TableCell>
        </TableRow>
      );
    }
    return content;
  };

  const getSummaryOfaStore = async (month) => {
    if (!selectedStoreId) {
      setSummaryLoading(false);
      return;
    }
    
    setSummaryLoading(true);
    let newMonth = months;
    if (month) {
      newMonth = month;
    }
    let storesSummary = await getDataWithToken(
      `getSummary?storeId=${selectedStoreId}&numberOfMonth=${newMonth}`,
      admin_panel_user,
      logout
    );

    if (storesSummary?.data?.code === 200) {
      let names = [];
      let data1 = [];
      let data2 = [];
      let years = [];
      let newTotalSummary = 0;
      let newTotalVerified = 0;
      if (storesSummary.data.data.summary.length > 0) {
        storesSummary.data.data.summary.map((item) => {
          newTotalSummary = newTotalSummary + parseInt(item.totalSummary);
          newTotalVerified = newTotalVerified + parseInt(item.totalVerified);
          names.push(item.month + " " + item.year);
          years.push(item.year);
          data1.push(item.totalSummary);
          data2.push(item.totalVerified);
        });
      }
      console.log("data1", data1);
      console.log("names ===========================================", names);
      setSummaryList(storesSummary.data.data.summary);
      setTotalSummary(newTotalSummary);
      setTotalVerified(newTotalVerified);
      setChartData({
        ...chartData,
        series: [
          {
            name: "Total Applied",
            data: data1,
          },
          {
            name: "Total Verified",
            data: data2,
          },
        ],
        options: {
          ...chartData.options,
          xaxis: {
            categories: names,
          },
        },
      });
    } else {
      setSummaryMessage(storesSummary.data.message.toString());
    }
    setDisplay(true);
    setSummaryLoading(false);
  };
  const getStoreDetails = async () => {
    if (!selectedStoreId) {
      setStoreDetailLoading(false);
      return;
    }
    
    setStoreDetailLoading(true);

    let storeData = await getDataWithToken(
      `getStoreInformation?storeId=${selectedStoreId}`,
      admin_panel_user,
      logout
    );

    if (storeData?.data?.code === 200) {
      setStoreDetails(storeData.data.data.storeDetails);
    } else {
      setStoreDetailMessage(storeData.data.message.toString());
    }
    setStoreDetailLoading(false);
  };
  const getData = async () => {
    if (admin_panel_user.token) {
      setStoreListLoading(true);

      let stores = await getDataWithToken(
        "getStoreInformation",
        admin_panel_user,
        logout
      );

      if (stores?.data?.code === 200) {
        if (stores.data?.data?.storeInfo?.length > 0) {
          setStoreList(stores.data.data.storeInfo);
          // Select the first store
          const firstStore = stores.data.data.storeInfo[0];
          setSelectedStoreId(firstStore.id);
          setSelectedProject(firstStore);
          setHasStores(true);
        } else {
          setStoreListMessage("No stores available");
          setStoreList([]);
          setSelectedStoreId(null);
          setHasStores(false);
        }
      } else if (stores?.data?.code === 404) {
        setStoreListMessage("No stores available");
        setStoreList([]);
        setSelectedStoreId(null);
        setHasStores(false);
      } else {
        setStoreListMessage(stores.data.message || "Failed to fetch stores");
        setStoreList([]);
        setSelectedStoreId(null);
        setHasStores(false);
      }
      setStoreListLoading(false);
    }
  };
  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (selectedStoreId) {
      getSummaryOfaStore();
      getStoreDetails();
    }
  }, [selectedStoreId]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);
  return (
    <>
      {/* <ColumnChart /> */}
      {/* {display && (
        <div id="chart">
          <Chart
            options={chartData.options}
            series={chartData.series}
            type="bar"
            height={215}
          />
        </div>
      )} */}
      
      {/* Current Project Card */}
      {hasStores && selectedProject && (
        <Grid container spacing={3} sx={{ marginBottom: "1.5rem" }}>
          <Grid item xs={12}>
            <Card sx={{ 
              backgroundColor: "#fff",
              boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.05)",
              borderRadius: "15px",
              border: "1px solid #E5FFFD"
            }}>
              <CardContent>
                <Grid container alignItems="center" justifyContent="space-between">
                  <Grid item xs={12} md={8}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: "0.75rem" }}>
                      <Avatar sx={{ 
                        backgroundColor: "#E5FFFD", 
                        color: "#016363", 
                        width: "50px", 
                        height: "50px" 
                      }}>
                        <BusinessIcon />
                      </Avatar>
                      <Box>
                        <Typography variant="h6" sx={{ 
                          color: "#016363", 
                          fontWeight: 600,
                          marginBottom: "0.25rem"
                        }}>
                          {selectedProject.storeName}
                        </Typography>
                        <Typography variant="body2" sx={{ 
                          color: "#666",
                          marginBottom: "0.5rem"
                        }}>
                          {selectedProject.storeDesc || "No description provided"}
                        </Typography>
                        <Box sx={{ display: "flex", gap: "0.5rem", flexWrap: "wrap" }}>
                          <Chip
                            label={`ID: ${selectedProject.id.slice(-8)}`}
                            size="small"
                            sx={{
                              backgroundColor: "#E5FFFD",
                              color: "#016363",
                              fontWeight: 500,
                              fontSize: "0.75rem"
                            }}
                          />
                          <Chip
                            label={`Created: ${moment(selectedProject.storeCreated).format("DD MMM YYYY")}`}
                            size="small"
                            sx={{
                              backgroundColor: "#E5FFFD",
                              color: "#016363",
                              fontWeight: 500,
                              fontSize: "0.75rem"
                            }}
                          />
                          <Chip
                            label="Active"
                            size="small"
                            sx={{
                              backgroundColor: "#E8F5E8",
                              color: "#2E7D32",
                              fontWeight: 500,
                              fontSize: "0.75rem"
                            }}
                          />
                        </Box>
                      </Box>
                    </Box>
                  </Grid>
                  
                  {storeList.length > 1 && (
                    <Grid item xs={12} md={4}>
                      <Box sx={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                        <SwapIcon sx={{ color: "#016363", fontSize: "1.25rem" }} />
                        <FormControl sx={{ minWidth: 200 }} size="small">
                          <InputLabel id="project-switch-label">
                            Switch Project
                          </InputLabel>
                          <Select
                            labelId="project-switch-label"
                            id="project-switch"
                            value={selectedStoreId || ""}
                            label="Switch Project"
                            onChange={handleProjectChange}
                            sx={{
                              "& .MuiOutlinedInput-notchedOutline": {
                                borderColor: "#E5FFFD",
                              },
                              "&:hover .MuiOutlinedInput-notchedOutline": {
                                borderColor: "#016363",
                              },
                              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                borderColor: "#016363",
                              },
                            }}
                          >
                            {storeList.map((project) => (
                              <MenuItem key={project.id} value={project.id}>
                                <Box sx={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                                  {project.id === selectedStoreId && (
                                    <CheckIcon sx={{ fontSize: "1rem", color: "#016363" }} />
                                  )}
                                  <Typography variant="body2">
                                    {project.storeName}
                                  </Typography>
                                </Box>
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Box>
                    </Grid>
                  )}
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      )}
      
      <Grid container alignItems="center" spacing={3}>
        <Grid item xs={12}>
          <Paper sx={{ py: 3, px: 0, height: "174px" }}>
            {" "}
            <Grid
              container
              alignItems="center"
              justifyContent="space-between"
              sx={{ mb: 1.125, px: 3 }}
            >
              <Grid item xs="auto">
                <Typography
                  variant="base"
                  color="text.main"
                  sx={{ fontWeight: 500 }}
                >
                  Summary
                  {selectedProject && (
                    <Typography
                      component="span"
                      variant="body2"
                      sx={{ 
                        color: "#016363", 
                        fontWeight: 400, 
                        marginLeft: 1,
                        fontStyle: "italic"
                      }}
                    >
                      • {selectedProject.storeName}
                    </Typography>
                  )}
                </Typography>
              </Grid>
              {/* <Grid item xs="auto">
                <Typography
                  variant="medium"
                  color="text.main"
                  sx={{ fontWeight: 400 }}
                >
                  Updated 1 month ago
                </Typography>
              </Grid> */}
            </Grid>
            <Divider />
            <Grid container alignItems="center" sx={{ mt: 2.5, px: 3 }}>
              <Grid item xs={3}>
                <Grid container alignItems="center" spacing={2}>
                  <Grid item xs="auto">
                    {" "}
                    <Avatar
                      sx={{
                        width: 36,
                        height: 36,
                        bgcolor: `${theme.palette.secondary.light}`,
                      }}
                    >
                      <SecurityIcon color={theme.palette.secondary.main} />
                    </Avatar>
                  </Grid>
                  <Grid item xs="auto">
                    <Typography
                      variant="h5"
                      color="text.light"
                      sx={{ fontWeight: 500 }}
                    >
                      <CountUp end={storeDetails?.totalUsed || 0} duration={2} />
                    </Typography>
                    <Typography
                      variant="medium"
                      color="text.main"
                      sx={{ fontWeight: 400 }}
                    >
                      e-KYC Attempted
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={3}>
                <Grid container alignItems="center" spacing={2}>
                  <Grid item xs="auto">
                    {" "}
                    <Avatar
                      sx={{
                        width: 36,
                        height: 36,
                        bgcolor: `${theme.palette.info.light}`,
                      }}
                    >
                      <VerifyIcon color={theme.palette.info.main} />
                    </Avatar>
                  </Grid>
                  <Grid item xs="auto">
                    <Typography
                      variant="h5"
                      color="text.light"
                      sx={{ fontWeight: 500 }}
                    >
                      <CountUp end={storeDetails?.totalVerified || 0} duration={2} />
                    </Typography>
                    <Typography
                      variant="medium"
                      color="text.main"
                      sx={{ fontWeight: 400 }}
                    >
                      Verified e-KYC
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={3}>
                <Grid container alignItems="center" spacing={2}>
                  <Grid item xs="auto">
                    {" "}
                    <Avatar
                      sx={{
                        width: 36,
                        height: 36,
                        bgcolor: `${theme.palette.warning.light}`,
                      }}
                    >
                      <ListIcon2 color={theme.palette.warning.main} />
                    </Avatar>
                  </Grid>
                  <Grid item xs="auto">
                    <Typography
                      variant="h5"
                      color="text.light"
                      sx={{ fontWeight: 500 }}
                    >
                      $
                      <CountUp
                        end={storeDetails?.totalPending || 0}
                        duration={2}
                        decimals={2}
                      />
                    </Typography>
                    <Typography
                      variant="medium"
                      color="text.main"
                      sx={{ fontWeight: 400 }}
                    >
                      Due Bill
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={3}>
                <Grid container alignItems="center" spacing={2}>
                  <Grid item xs="auto">
                    {" "}
                    <Avatar
                      sx={{
                        width: 36,
                        height: 36,
                        bgcolor: `${theme.palette.success.light}`,
                      }}
                    >
                      <MoneyIcon color={theme.palette.success.main} />
                    </Avatar>
                  </Grid>
                  <Grid item xs="auto">
                    <Typography
                      variant="h5"
                      color="text.light"
                      sx={{ fontWeight: 500 }}
                    >
                      $
                      <CountUp
                        end={storeDetails?.totalPaid || 0}
                        duration={2}
                        decimals={2}
                      />
                    </Typography>
                    <Typography
                      variant="medium"
                      color="text.main"
                      sx={{ fontWeight: 400 }}
                    >
                      Paid
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
        {/* <Grid item xs={3}>
          <Paper sx={{ p: 3, height: "174px", display: "flex" }}>
            <Grid container alignItems="center" spacing={2.5}>
              <Grid item xs="auto">
                <Badge
                  badgeContent={4}
                  color="primary"
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                  }}
                  sx={{
                    "& .MuiBadge-badge": {
                      right: "15px",
                      bottom: "7px",
                      minWidth: "30px",
                      height: "30px",
                      borderRadius: "50%",
                      boxShadow: "0px 4px 18px 0px rgba(75, 70, 92, 0.10)",
                    },
                  }}
                >
                  <Avatar
                    alt="Remy Sharp"
                    src="/images/user.svg"
                    sx={{
                      width: "96px",
                      height: "96px",
                      border: `2px solid ${theme.palette.text.fade}`,
                    }}
                  />
                </Badge>
              </Grid>
              <Grid item xs="auto">
                <Typography
                  variant="base"
                  color="text.main"
                  sx={{ fontWeight: 500 }}
                >
                  Cameron Williamson
                </Typography>
                <Typography
                  variant="medium"
                  color="text.main"
                  sx={{ fontWeight: 400 }}
                >
                  User Type Goes Here
                </Typography>
                <Box sx={{ mt: 1.5 }}>
                  <IconButton
                    sx={{
                      mr: 0.75,
                      border: `1px solid ${theme.palette.border.main}`,
                    }}
                  >
                   
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M8 4.29333V6.51334"
                        stroke={theme.palette.primary.main}
                        stroke-width="1.5"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                      />
                      <path
                        d="M8.01327 1.33334C5.55993 1.33334 3.57327 3.32001 3.57327 5.77334V7.17334C3.57327 7.62668 3.3866 8.30668 3.15327 8.69334L2.3066 10.1067C1.7866 10.98 2.1466 11.9533 3.1066 12.2733C6.29327 13.3333 9.73993 13.3333 12.9266 12.2733C13.8266 11.9733 14.2133 10.92 13.7266 10.1067L12.8799 8.69334C12.6466 8.30668 12.4599 7.62001 12.4599 7.17334V5.77334C12.4533 3.33334 10.4533 1.33334 8.01327 1.33334Z"
                        stroke={theme.palette.primary.main}
                        stroke-width="1.5"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                      />
                      <path
                        d="M10.22 12.5467C10.22 13.7667 9.22003 14.7667 8.00003 14.7667C7.39336 14.7667 6.83336 14.5133 6.43336 14.1133C6.03336 13.7133 5.78003 13.1533 5.78003 12.5467"
                        stroke={theme.palette.primary.main}
                        stroke-width="1.5"
                        stroke-miterlimit="10"
                      />
                    </svg>
                  </IconButton>
                  <IconButton
                    sx={{
                      mr: 0.75,
                      border: `1px solid ${theme.palette.border.main}`,
                    }}
                    onClick={toggleTheme}
                  >
                    <MoonIcon color={theme.palette.primary.main} />
                  </IconButton>
                  <IconButton
                    sx={{
                      mr: 0.75,
                      border: `1px solid ${theme.palette.border.main}`,
                    }}
                  >
                  
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M10.3866 8.00001C10.3866 9.32001 9.31995 10.3867 7.99995 10.3867C6.67995 10.3867 5.61328 9.32001 5.61328 8.00001C5.61328 6.68001 6.67995 5.61334 7.99995 5.61334C9.31995 5.61334 10.3866 6.68001 10.3866 8.00001Z"
                        stroke={theme.palette.primary.main}
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M7.9999 13.5133C10.3532 13.5133 12.5466 12.1267 14.0732 9.72668C14.6732 8.78668 14.6732 7.20668 14.0732 6.26668C12.5466 3.86668 10.3532 2.48001 7.9999 2.48001C5.64656 2.48001 3.45323 3.86668 1.92656 6.26668C1.32656 7.20668 1.32656 8.78668 1.92656 9.72668C3.45323 12.1267 5.64656 13.5133 7.9999 13.5133Z"
                        stroke={theme.palette.primary.main}
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </IconButton>
                </Box>
              </Grid>
            </Grid>
          </Paper>
        </Grid> */}
        
        {!hasStores ? (
          <Grid item xs={12}>
            <Paper sx={{ p: 4, textAlign: "center" }}>
              <Typography variant="h5" sx={{ color: "#016363", marginBottom: "1rem" }}>
                No Projects Available
              </Typography>
              <Typography variant="body1" sx={{ color: "#666", marginBottom: "2rem" }}>
                You don't have any projects yet. Create your first project to get started with analytics.
              </Typography>
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#016363",
                  color: "white",
                  "&:hover": {
                    backgroundColor: "#014a4a",
                  },
                }}
                onClick={() => window.location.href = "/projects"}
              >
                Go to Projects
              </Button>
            </Paper>
          </Grid>
        ) : (
          <Grid item xs={12}>
            <Paper sx={{ p: 3 }}>
              <Grid
                container
                direction="column"
                sx={{ minHeight: "410px" }}
              >
              <Grid
                container
                alignItems="center"
                justifyContent="space-between"
              >
                <Grid item xs="auto">
                  <Typography
                    variant="base"
                    color="text.main"
                    sx={{ fontWeight: 500 }}
                  >
                    e-KYC Attempted vs Verified
                    {selectedProject && (
                      <Typography
                        component="span"
                        variant="body2"
                        sx={{ 
                          color: "#016363", 
                          fontWeight: 400, 
                          marginLeft: 1,
                          fontStyle: "italic"
                        }}
                      >
                        • {selectedProject.storeName}
                      </Typography>
                    )}
                  </Typography>
                  <Typography
                    variant="medium"
                    color="text.main"
                    sx={{ fontWeight: 400 }}
                  >
                    {months === 12 ? "Last 12 months overview" : 
                     months === 6 ? "Last 6 months overview" : 
                     "Last 3 months overview"}
                  </Typography>
                </Grid>
                <Grid item xs="auto">
                  <FormControl sx={{ minWidth: 120 }} size="small">
                    <InputLabel id="demo-simple-select-label">
                      Time Period
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={months}
                      label="Time Period"
                      onChange={handleChange}
                    >
                      <MenuItem value={12}>Last 12 Months</MenuItem>
                      <MenuItem value={6}>Last 6 Months</MenuItem>
                      <MenuItem value={3}>Last 3 Months</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>

              <Grid container alignItems="end" spacing={3}>
                <Grid item xs={12}>
                  <div style={{ width: "100%", position: "relative" }}>
                    {summaryLoading && (
                      <SyncLoader
                        color={theme.palette.primary.main}
                        loading={true}
                        size={15}
                        speedMultiplier={0.5}
                        style={{
                          position: "absolute",
                          left: "50%",
                          top: "30%",
                          zIndex: 100,
                        }}
                      />
                    )}
                    <div
                      id="chart"
                      className={classes.chartContainer}
                      style={{ opacity: summaryLoading && 0.5 }}
                    >
                      <Chart
                        options={chartData.options}
                        series={chartData.series}
                        type="bar"
                        height={280}
                      />
                    </div>
                  </div>
                </Grid>
              </Grid>
              <Box
                sx={{
                  px: 2.5,
                  py: 2,
                  borderRadius: "6px",
                  border: `1px solid ${theme.palette.border.main}`,
                  width: "100%",
                }}
              >
                <Grid container alignItems="center" spacing={3}>
                  <Grid item xs={6}>
                    <Grid
                      container
                      alignItems="center"
                      spacing={1}
                      sx={{ mb: 1.125 }}
                    >
                      <Grid item xs="auto">
                        <Avatar
                          sx={{ bgcolor: `${theme.palette.primary.light}` }}
                          variant="rounded"
                        >
                          <UncompletedIcon color={theme.palette.primary.main} />
                        </Avatar>
                      </Grid>
                      <Grid item xs="auto">
                        <Typography
                          variant="h5"
                          color="text.light"
                          className="fw6"
                        >
                          <CountUp end={totalSummary} duration={2} />
                        </Typography>
                      </Grid>
                    </Grid>
                    <Typography
                      variant="medium"
                      color="text.light"
                      sx={{ mb: 1.125, fontWeight: 500 }}
                    >
                      Total Attempts
                    </Typography>
                    <Box sx={{ width: "100%" }}>
                      <LinearProgress
                        variant="determinate"
                        value={100}
                        color="primary"
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={6}>
                    <Grid
                      container
                      alignItems="center"
                      spacing={1}
                      sx={{ mb: 1.125 }}
                    >
                      <Grid item xs="auto">
                        <Avatar
                          sx={{ bgcolor: `${theme.palette.success.light}` }}
                          variant="rounded"
                        >
                          <VerifyIcon color={theme.palette.success.main} />
                        </Avatar>
                      </Grid>
                      <Grid item xs="auto">
                        <Typography
                          variant="h5"
                          color="text.light"
                          className="fw6"
                        >
                          <CountUp end={totalVerified} duration={2} />
                        </Typography>
                      </Grid>
                    </Grid>
                    <Typography
                      variant="medium"
                      color="text.light"
                      sx={{ mb: 1.125, fontWeight: 500 }}
                    >
                      Total Verified Profile
                    </Typography>
                    <Box sx={{ width: "100%" }}>
                      <LinearProgress
                        variant="determinate"
                        value={100}
                        color="success"
                      />
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Paper>
        </Grid>
        )}
        {/* <Grid item xs={4}>
          <Paper sx={{ p: 3, minHeight: "392px" }}>
            {" "}
            <Grid
              container
              alignItems="center"
              justifyContent="space-between"
              sx={{ mb: 3 }}
            >
              <Grid item xs="auto">
                {" "}
                <Typography
                  variant="base"
                  color="text.main"
                  sx={{ fontWeight: 500 }}
                >
                  Sales by Countries
                </Typography>
                <Typography
                  variant="medium"
                  color="text.main"
                  sx={{ fontWeight: 400 }}
                >
                  Monthly Sales Overview
                </Typography>
              </Grid>
              <Grid item xs="auto">
                <IconButton>
                  <MenuIcon color={theme.palette.text.light} />
                </IconButton>
              </Grid>
            </Grid>
            <Table aria-label="simple table">
              <TableBody>
                {[1, 2, 3, 4, 5].map(() => (
                  <TableRow sx={{ "& td": { border: 0 } }}>
                    <TableCell sx={{ width: "30px" }}>
                      <Avatar
                        variant="rounded"
                        src="/images/flag.png"
                        sx={{ width: 32, height: 32 }}
                      />
                    </TableCell>
                    <TableCell>
                      <Typography
                        variant="medium"
                        color="text.main"
                        sx={{ fontWeight: 500 }}
                      >
                        $8.45k
                      </Typography>
                      <Typography
                        variant="medium"
                        color="text.light"
                        sx={{ fontWeight: 400 }}
                      >
                        United Arab Emirates
                      </Typography>
                    </TableCell>
                    <TableCell align="right">
                      <Typography
                        variant="medium"
                        color="success.main"
                        sx={{ fontWeight: 400 }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="9"
                          viewBox="0 0 16 9"
                          fill="none"
                        >
                          <path
                            d="M14.5999 7.54158L9.16657 2.10825C8.5249 1.46658 7.4749 1.46658 6.83324 2.10825L1.3999 7.54158"
                            stroke="#69CB1C"
                            stroke-width="1.5"
                            stroke-miterlimit="10"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>{" "}
                        &nbsp; 25.8%
                      </Typography>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Paper>
        </Grid> */}
        {/* <Grid item xs={4}>
          <Paper sx={{ p: 3, minHeight: "392px" }}>
            {" "}
            <Grid container alignItems="center" justifyContent="space-between">
              <Grid item xs="auto">
                {" "}
                <Typography
                  variant="base"
                  color="text.main"
                  sx={{ fontWeight: 500 }}
                >
                  Total Demo Requested
                </Typography>
              </Grid>
              <Grid item xs="auto">
                <IconButton>
                  <MenuIcon color={theme.palette.text.light} />
                </IconButton>
              </Grid>
            </Grid>
            <Grid container alignItems="center" spacing={1} sx={{ mb: 3 }}>
              <Grid item xs="auto">
                <Typography
                  variant="h2"
                  color="text.main"
                  sx={{ fontWeight: 600 }}
                >
                  298.5k
                </Typography>
              </Grid>
              <Grid item xs="auto">
                <Typography
                  variant="medium"
                  color="success.main"
                  sx={{ fontWeight: 400 }}
                >
                  0.3%
                </Typography>
              </Grid>
            </Grid>
          
            <AreaChart />
          </Paper>
        </Grid> */}
        {/* <Grid item xs={4}>
          <Paper sx={{ p: 3, minHeight: "392px" }}>
            {" "}
            <Grid
              container
              alignItems="center"
              justifyContent="space-between"
              sx={{ mb: 3 }}
            >
              <Grid item xs="auto">
                {" "}
                <Typography
                  variant="base"
                  color="text.main"
                  sx={{ fontWeight: 500 }}
                >
                  Monthly Requested State
                </Typography>
                <Typography
                  variant="medium"
                  color="text.main"
                  sx={{ fontWeight: 400 }}
                >
                  8.52k requested
                </Typography>
              </Grid>
              <Grid item xs="auto">
                <IconButton>
                  <MenuIcon color={theme.palette.text.light} />
                </IconButton>
              </Grid>
            </Grid>
            <Table aria-label="simple table">
              <TableBody>
                <TableRow sx={{ "& td": { border: 0 } }}>
                  <TableCell sx={{ width: "30px" }}>
                    <Avatar
                      sx={{ bgcolor: `${theme.palette.success.light}` }}
                      variant="rounded"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                      >
                        <path
                          d="M12.75 15.375H5.25C3 15.375 1.5 14.25 1.5 11.625V6.375C1.5 3.75 3 2.625 5.25 2.625H12.75C15 2.625 16.5 3.75 16.5 6.375V11.625C16.5 14.25 15 15.375 12.75 15.375Z"
                          stroke={theme.palette.success.main}
                          stroke-width="1.5"
                          stroke-miterlimit="10"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M12.75 6.75L10.4025 8.625C9.63 9.24 8.3625 9.24 7.59 8.625L5.25 6.75"
                          stroke={theme.palette.success.main}
                          stroke-width="1.5"
                          stroke-miterlimit="10"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </Avatar>
                  </TableCell>
                  <TableCell>
                    <Typography
                      variant="medium"
                      color="text.main"
                      sx={{ fontWeight: 500 }}
                    >
                      Emails
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    <Typography
                      variant="medium"
                      color="text.light"
                      sx={{ fontWeight: 400 }}
                    >
                      12,346
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    <Typography
                      variant="medium"
                      color="success.main"
                      sx={{ fontWeight: 400 }}
                    >
                      0.3%
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow sx={{ "& td": { border: 0 } }}>
                  <TableCell sx={{ width: "30px" }}>
                    <Avatar
                      sx={{ bgcolor: `${theme.palette.info.light}` }}
                      variant="rounded"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                      >
                        <path
                          d="M13.8524 12.6225L14.1449 14.9925C14.2199 15.615 13.5524 16.05 13.0199 15.7275L9.87738 13.86C9.53238 13.86 9.19489 13.8375 8.86489 13.7925C9.41989 13.14 9.74989 12.315 9.74989 11.4225C9.74989 9.29249 7.90489 7.56752 5.62489 7.56752C4.75489 7.56752 3.95239 7.815 3.28489 8.25C3.26239 8.0625 3.25488 7.87499 3.25488 7.67999C3.25488 4.26749 6.21738 1.5 9.87738 1.5C13.5374 1.5 16.4999 4.26749 16.4999 7.67999C16.4999 9.70499 15.4574 11.4975 13.8524 12.6225Z"
                          stroke={theme.palette.info.main}
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M9.75 11.4225C9.75 12.315 9.42001 13.14 8.86501 13.7925C8.12251 14.6925 6.945 15.27 5.625 15.27L3.6675 16.4325C3.3375 16.635 2.9175 16.3575 2.9625 15.975L3.15 14.4975C2.145 13.8 1.5 12.6825 1.5 11.4225C1.5 10.1025 2.205 8.93998 3.285 8.24998C3.9525 7.81498 4.755 7.5675 5.625 7.5675C7.905 7.5675 9.75 9.29247 9.75 11.4225Z"
                          stroke={theme.palette.info.main}
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </Avatar>
                  </TableCell>
                  <TableCell>
                    <Typography
                      variant="medium"
                      color="text.main"
                      sx={{ fontWeight: 500 }}
                    >
                      Direct massage
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    <Typography
                      variant="medium"
                      color="text.light"
                      sx={{ fontWeight: 400 }}
                    >
                      8,734
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    <Typography
                      variant="medium"
                      color="success.main"
                      sx={{ fontWeight: 400 }}
                    >
                      2.1%
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow sx={{ "& td": { border: 0 } }}>
                  <TableCell sx={{ width: "30px" }}>
                    <Avatar
                      sx={{ bgcolor: `${theme.palette.warning.light}` }}
                      variant="rounded"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                      >
                        <path
                          d="M16.4775 13.7475C16.4775 14.0175 16.4175 14.295 16.29 14.565C16.1625 14.835 15.9975 15.09 15.78 15.33C15.4125 15.735 15.0075 16.0275 14.55 16.215C14.1 16.4025 13.6125 16.5 13.0875 16.5C12.3225 16.5 11.505 16.32 10.6425 15.9525C9.78 15.585 8.9175 15.09 8.0625 14.4675C7.2 13.8375 6.3825 13.14 5.6025 12.3675C4.83 11.5875 4.1325 10.77 3.51 9.915C2.895 9.06 2.4 8.205 2.04 7.3575C1.68 6.5025 1.5 5.685 1.5 4.905C1.5 4.395 1.59 3.9075 1.77 3.4575C1.95 3 2.235 2.58 2.6325 2.205C3.1125 1.7325 3.6375 1.5 4.1925 1.5C4.4025 1.5 4.6125 1.545 4.8 1.635C4.995 1.725 5.1675 1.86 5.3025 2.055L7.0425 4.5075C7.1775 4.695 7.275 4.8675 7.3425 5.0325C7.41 5.19 7.4475 5.3475 7.4475 5.49C7.4475 5.67 7.395 5.85 7.29 6.0225C7.1925 6.195 7.05 6.375 6.87 6.555L6.3 7.1475C6.2175 7.23 6.18 7.3275 6.18 7.4475C6.18 7.5075 6.1875 7.56 6.2025 7.62C6.225 7.68 6.2475 7.725 6.2625 7.77C6.3975 8.0175 6.63 8.34 6.96 8.73C7.2975 9.12 7.6575 9.5175 8.0475 9.915C8.4525 10.3125 8.8425 10.68 9.24 11.0175C9.63 11.3475 9.9525 11.5725 10.2075 11.7075C10.245 11.7225 10.29 11.745 10.3425 11.7675C10.4025 11.79 10.4625 11.7975 10.53 11.7975C10.6575 11.7975 10.755 11.7525 10.8375 11.67L11.4075 11.1075C11.595 10.92 11.775 10.7775 11.9475 10.6875C12.12 10.5825 12.2925 10.53 12.48 10.53C12.6225 10.53 12.7725 10.56 12.9375 10.6275C13.1025 10.695 13.275 10.7925 13.4625 10.92L15.945 12.6825C16.14 12.8175 16.275 12.975 16.3575 13.1625C16.4325 13.35 16.4775 13.5375 16.4775 13.7475Z"
                          stroke={theme.palette.warning.main}
                          stroke-width="1.5"
                          stroke-miterlimit="10"
                        />
                        <path
                          d="M13.875 6.75C13.875 6.3 13.5225 5.61 12.9975 5.0475C12.5175 4.53 11.88 4.125 11.25 4.125"
                          stroke={theme.palette.warning.main}
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M16.5 6.75C16.5 3.8475 14.1525 1.5 11.25 1.5"
                          stroke={theme.palette.warning.main}
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </Avatar>
                  </TableCell>
                  <TableCell>
                    <Typography
                      variant="medium"
                      color="text.main"
                      sx={{ fontWeight: 500 }}
                    >
                      Phone Call
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    <Typography
                      variant="medium"
                      color="text.light"
                      sx={{ fontWeight: 400 }}
                    >
                      967
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    <Typography
                      variant="medium"
                      color="error.main"
                      sx={{ fontWeight: 400 }}
                    >
                      1.4%
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow sx={{ "& td": { border: 0 } }}>
                  <TableCell sx={{ width: "30px" }}>
                    <Avatar
                      sx={{ bgcolor: `${theme.palette.error.light}` }}
                      variant="rounded"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="14"
                        viewBox="0 0 16 14"
                        fill="none"
                      >
                        <path
                          d="M12.75 0.999969H3.25C2.14543 0.999969 1.25 1.8954 1.25 2.99997V11C1.25 12.1045 2.14543 13 3.25 13H12.75C13.8546 13 14.75 12.1045 14.75 11V2.99997C14.75 1.8954 13.8546 0.999969 12.75 0.999969Z"
                          stroke={theme.palette.error.main}
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M14.75 3.99997H1.25"
                          stroke={theme.palette.error.main}
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M2.75 2.5H5.75"
                          stroke={theme.palette.error.main}
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </Avatar>
                  </TableCell>
                  <TableCell>
                    <Typography
                      variant="medium"
                      color="text.main"
                      sx={{ fontWeight: 500 }}
                    >
                      Via Portal
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    <Typography
                      variant="medium"
                      color="text.light"
                      sx={{ fontWeight: 400 }}
                    >
                      345
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    <Typography
                      variant="medium"
                      color="success.main"
                      sx={{ fontWeight: 400 }}
                    >
                      8.5%
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow sx={{ "& td": { border: 0 } }}>
                  <TableCell sx={{ width: "30px" }}>
                    <Avatar
                      sx={{ bgcolor: `${theme.palette.success.light}` }}
                      variant="rounded"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                      >
                        <path
                          d="M12.75 15.375H5.25C3 15.375 1.5 14.25 1.5 11.625V6.375C1.5 3.75 3 2.625 5.25 2.625H12.75C15 2.625 16.5 3.75 16.5 6.375V11.625C16.5 14.25 15 15.375 12.75 15.375Z"
                          stroke={theme.palette.success.main}
                          stroke-width="1.5"
                          stroke-miterlimit="10"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M12.75 6.75L10.4025 8.625C9.63 9.24 8.3625 9.24 7.59 8.625L5.25 6.75"
                          stroke={theme.palette.success.main}
                          stroke-width="1.5"
                          stroke-miterlimit="10"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </Avatar>
                  </TableCell>
                  <TableCell>
                    <Typography
                      variant="medium"
                      color="text.main"
                      sx={{ fontWeight: 500 }}
                    >
                      Emails
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    <Typography
                      variant="medium"
                      color="text.light"
                      sx={{ fontWeight: 400 }}
                    >
                      12,346
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    <Typography
                      variant="medium"
                      color="success.main"
                      sx={{ fontWeight: 400 }}
                    >
                      0.3%
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow sx={{ "& td": { border: 0 } }}>
                  <TableCell sx={{ width: "30px" }}>
                    <Avatar
                      sx={{ bgcolor: `${theme.palette.info.light}` }}
                      variant="rounded"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                      >
                        <path
                          d="M13.8524 12.6225L14.1449 14.9925C14.2199 15.615 13.5524 16.05 13.0199 15.7275L9.87738 13.86C9.53238 13.86 9.19489 13.8375 8.86489 13.7925C9.41989 13.14 9.74989 12.315 9.74989 11.4225C9.74989 9.29249 7.90489 7.56752 5.62489 7.56752C4.75489 7.56752 3.95239 7.815 3.28489 8.25C3.26239 8.0625 3.25488 7.87499 3.25488 7.67999C3.25488 4.26749 6.21738 1.5 9.87738 1.5C13.5374 1.5 16.4999 4.26749 16.4999 7.67999C16.4999 9.70499 15.4574 11.4975 13.8524 12.6225Z"
                          stroke={theme.palette.info.main}
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M9.75 11.4225C9.75 12.315 9.42001 13.14 8.86501 13.7925C8.12251 14.6925 6.945 15.27 5.625 15.27L3.6675 16.4325C3.3375 16.635 2.9175 16.3575 2.9625 15.975L3.15 14.4975C2.145 13.8 1.5 12.6825 1.5 11.4225C1.5 10.1025 2.205 8.93998 3.285 8.24998C3.9525 7.81498 4.755 7.5675 5.625 7.5675C7.905 7.5675 9.75 9.29247 9.75 11.4225Z"
                          stroke={theme.palette.info.main}
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </Avatar>
                  </TableCell>
                  <TableCell>
                    <Typography
                      variant="medium"
                      color="text.main"
                      sx={{ fontWeight: 500 }}
                    >
                      Direct massage
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    <Typography
                      variant="medium"
                      color="text.light"
                      sx={{ fontWeight: 400 }}
                    >
                      8,734
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    <Typography
                      variant="medium"
                      color="success.main"
                      sx={{ fontWeight: 400 }}
                    >
                      2.1%
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow sx={{ "& td": { border: 0 } }}>
                  <TableCell sx={{ width: "30px" }}>
                    <Avatar
                      sx={{ bgcolor: `${theme.palette.warning.light}` }}
                      variant="rounded"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                      >
                        <path
                          d="M16.4775 13.7475C16.4775 14.0175 16.4175 14.295 16.29 14.565C16.1625 14.835 15.9975 15.09 15.78 15.33C15.4125 15.735 15.0075 16.0275 14.55 16.215C14.1 16.4025 13.6125 16.5 13.0875 16.5C12.3225 16.5 11.505 16.32 10.6425 15.9525C9.78 15.585 8.9175 15.09 8.0625 14.4675C7.2 13.8375 6.3825 13.14 5.6025 12.3675C4.83 11.5875 4.1325 10.77 3.51 9.915C2.895 9.06 2.4 8.205 2.04 7.3575C1.68 6.5025 1.5 5.685 1.5 4.905C1.5 4.395 1.59 3.9075 1.77 3.4575C1.95 3 2.235 2.58 2.6325 2.205C3.1125 1.7325 3.6375 1.5 4.1925 1.5C4.4025 1.5 4.6125 1.545 4.8 1.635C4.995 1.725 5.1675 1.86 5.3025 2.055L7.0425 4.5075C7.1775 4.695 7.275 4.8675 7.3425 5.0325C7.41 5.19 7.4475 5.3475 7.4475 5.49C7.4475 5.67 7.395 5.85 7.29 6.0225C7.1925 6.195 7.05 6.375 6.87 6.555L6.3 7.1475C6.2175 7.23 6.18 7.3275 6.18 7.4475C6.18 7.5075 6.1875 7.56 6.2025 7.62C6.225 7.68 6.2475 7.725 6.2625 7.77C6.3975 8.0175 6.63 8.34 6.96 8.73C7.2975 9.12 7.6575 9.5175 8.0475 9.915C8.4525 10.3125 8.8425 10.68 9.24 11.0175C9.63 11.3475 9.9525 11.5725 10.2075 11.7075C10.245 11.7225 10.29 11.745 10.3425 11.7675C10.4025 11.79 10.4625 11.7975 10.53 11.7975C10.6575 11.7975 10.755 11.7525 10.8375 11.67L11.4075 11.1075C11.595 10.92 11.775 10.7775 11.9475 10.6875C12.12 10.5825 12.2925 10.53 12.48 10.53C12.6225 10.53 12.7725 10.56 12.9375 10.6275C13.1025 10.695 13.275 10.7925 13.4625 10.92L15.945 12.6825C16.14 12.8175 16.275 12.975 16.3575 13.1625C16.4325 13.35 16.4775 13.5375 16.4775 13.7475Z"
                          stroke={theme.palette.warning.main}
                          stroke-width="1.5"
                          stroke-miterlimit="10"
                        />
                        <path
                          d="M13.875 6.75C13.875 6.3 13.5225 5.61 12.9975 5.0475C12.5175 4.53 11.88 4.125 11.25 4.125"
                          stroke={theme.palette.warning.main}
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M16.5 6.75C16.5 3.8475 14.1525 1.5 11.25 1.5"
                          stroke={theme.palette.warning.main}
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </Avatar>
                  </TableCell>
                  <TableCell>
                    <Typography
                      variant="medium"
                      color="text.main"
                      sx={{ fontWeight: 500 }}
                    >
                      Phone Call
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    <Typography
                      variant="medium"
                      color="text.light"
                      sx={{ fontWeight: 400 }}
                    >
                      967
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    <Typography
                      variant="medium"
                      color="error.main"
                      sx={{ fontWeight: 400 }}
                    >
                      1.4%
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Paper>
        </Grid> */}
      </Grid>
    </>
  );
};

export default Dashboard;
